export const CONTAINER_DEFAULT_SORT_BY = 'addedAt';
export const BL_DEFAULT_SORT_BY = 'updatedAt';
export const SHIPMENT_DEFAULT_SORT_BY = 'updatedAt';

export enum SearchTypeListKey {
  BlId = 'blIdList',
  HblId = 'hblIdList',
  ContainerId = 'containerIdList',
  BookingId = 'bookingIdList',
  InvoiceId = 'invoiceIdList',
  InternalReferenceNumber = 'internalReferenceNumberList',
  CustomerReferenceNumber = 'customerReferenceNumberList',
  SupplierReferenceNumber = 'supplierReferenceNumberList',
  ExecutionReferenceNumber = 'executionReferenceNumberList',
  PurchaseOrderNumber = 'purchaseOrderNumberList',
  SONumber = 'soNumberList',
  StuffingId = 'stuffingIdList',
  ProductId = 'products',
}
